<template lang="pug">
    div(class="_btngroup")
        //-
            @slot Pass in a div containing multiple buttons here
        //
        slot
</template>

<script>
    /**
    * A group of buttons with relevant spacing
    */
    export default {
        name: 'ib-button-group'
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._btngroup {
        &.wgrow {
            display: -webkit-flex;
            display: flex;
            -webkit-flex-direction: row;
            flex-direction: row;
            ._btn {
                -webkit-flex: 1 1 auto;
                flex: 1 1 auto;
            }
        }
    }
</style>

<docs>
    Basic Example:

    ```jsx
        <ib-button-group>
            <ib-button>Button 1</ib-button>
            <ib-button>Button 2</ib-button>
            <ib-button>Button 3</ib-button>
        </ib-button-group>
    ```

    Width Growing:

    ```jsx
        <ib-button-group class="wgrow">
            <ib-button>Button 1</ib-button>
            <ib-button>Button 2</ib-button>
            <ib-button>Button 3</ib-button>
        </ib-button-group>
    ```
</docs>
